var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentType)?_c('v-dialog',{attrs:{"width":this.width},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('v-card',{staticClass:"card--flex-toolbar"},[_c('v-toolbar',{attrs:{"flat":"","extended":!!_vm.viewItem,"extension-height":"48"}},[_c('v-icon',{attrs:{"large":"","left":""},domProps:{"textContent":_vm._s(_vm.componentType.icon || 'extension')}}),_c('div',{staticClass:"title"},[_c('h1',{staticClass:"headline"},[_vm._v("Editar "+_vm._s(_vm.componentType.titleSingle || _vm.componentType.title || 'Componente'))]),(_vm.displayName)?_c('h3',{staticClass:"subtitle-1",domProps:{"textContent":_vm._s(_vm.displayName)}}):_vm._e()]),_c('v-spacer'),_c('v-btn',{attrs:{"text":"","icon":""},on:{"click":function($event){_vm.open = false}}},[_c('v-icon',[_vm._v("close")])],1),(_vm.viewItem || _vm.hasAdditionalTabs)?_c('v-tabs',{attrs:{"slot":"extension","fixed-tabs":"","background-color":"transparent","centered":""},slot:"extension",model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_c('v-tab',{attrs:{"href":"#component"}},[_vm._v(_vm._s(_vm.componentType.titleSingle || _vm.componentType.title || 'Componente'))]),_vm._l((_vm.additionalTabs),function(tab,key){return _c('v-tab',{key:key,attrs:{"href":'#' + key},domProps:{"textContent":_vm._s(tab)}})}),(_vm.viewItem)?_c('v-tab',{attrs:{"href":"#viewItem"}},[_vm._v("Diseño")]):_vm._e()],2):_vm._e()],1),_c('v-tabs-items',{model:{value:(_vm.actualTab),callback:function ($$v) {_vm.actualTab=$$v},expression:"actualTab"}},[_c('v-tab-item',{attrs:{"value":"component"}},[(_vm.componentType.edit)?_c('v-container',{staticClass:"edit-modal-container"},[_c(_vm.componentType.edit,{tag:"component",attrs:{"environmentId":_vm.environmentId,"environmentUser":_vm.environmentUser,"componentId":_vm.componentId,"currentTab":_vm.currentTab},on:{"dismiss":function($event){_vm.open = false},"save":_vm.handleSave,"delete":_vm.handleDelete,"error":_vm.handleError,"name":_vm.updateName,"additionalTabs":_vm.updateAdditionalTabs,"update:currentTab":function($event){_vm.currentTab=$event},"update:current-tab":function($event){_vm.currentTab=$event}}})],1):_c('v-container',[_c('v-card-text',{staticClass:"text-center"},[_c('v-icon',{attrs:{"size":"48"}},[_vm._v("error")]),_c('br'),_c('div',[_vm._v("El componente no es editable.")])],1)],1)],1),(_vm.viewItem)?_c('v-tab-item',{attrs:{"value":"viewItem"}},[_c('v-container',{staticClass:"edit-modal-container"},[_c('Fields',{attrs:{"environmentVariables":{ environmentId: _vm.environmentId },"schema":{
              helpBlockId: {
                type: 'string',
                fieldType: 'blockSelect',
                label: 'Bloque de ayuda',
                fieldOptions: {
                  multi: false
                },
                optional: true,
                newDesign: true
              },
              titleColor: {
                type: 'string',
                label: 'Color del título',
                fieldType: 'colorPicker',
                optional: true,
                newDesign: true
              },
              titleBackground: {
                type: 'string',
                label: 'Imagen de encabezado (URL)',
                optional: true,
                newDesign: true
              },
              cssClass: {
                type: 'string',
                label: 'Clases CSS',
                description: 'Separadas por espacio',
                optional: true,
                newDesign: true
              },
              hideBorders: {
                type: 'boolean',
                label: 'Sin Bordes',
                fieldType: 'checkbox',
                optional: true,
                newDesign: true
              },
              hidePrint: {
                type: 'boolean',
                label: 'Ocultar al imprimir',
                fieldType: 'checkbox',
                optional: true,
                newDesign: true
              },
              fullSize: {
                label: 'Permitir expandir a pantalla completa.',
                type: 'boolean',
                fieldType: 'checkbox',
                optional: true,
                newDesign: true
              }
            }},model:{value:(_vm.viewItemSync),callback:function ($$v) {_vm.viewItemSync=$$v},expression:"viewItemSync"}})],1)],1):_vm._e()],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }